module.exports = __webpack_public_path__ + "static/media/Australia.b4c51538.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/Australia.jpg
// module id = 327
// module chunks = 21